import { Link } from "react-router-dom";
import { ArrowRight, Check, Phone } from "lucide-react";
import SEO from "../components/SEO";
import EditorialMarquee from "../components/EditorialMarquee";
import StatusBadge from "../components/StatusBadge";
import { FadeUp, MaskedLines, SectionLabel } from "../components/Reveal";
import { IMG, PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const SERVICES_DETAIL = [
    {
        title: "Ouverture de porte",
        price: "dès 60€ TTC",
        to: "/ouverture-de-porte",
        text: "Clés égarées, laissées sur la table de nuit ou coincées dans la serrure ? Notre équipe déverrouille votre porte en un minimum de temps et vous donne des conseils pratiques pour éviter que cela se reproduise : entretien de la serrure, double des clés…",
    },
    {
        title: "Remplacement de serrure",
        price: "dès 85€",
        to: "/changement-de-serrure",
        text: "Avec les années, les serrures s'abîment, deviennent difficiles à ouvrir et peuvent casser votre clé. Nous remplaçons vos serrures en un temps record, sur Paris 75 et toute l'Île-de-France. Un justificatif de domicile vous sera demandé avant l'intervention.",
    },
    {
        title: "Reproduction de clé",
        price: "dès 5€",
        to: "/double-de-cle",
        text: "Disposer d'un double de clé vous évite de changer de serrure en cas de perte et permet à plusieurs utilisateurs d'accéder à la même porte. Clé plate : 5€. Clé spéciale : à partir de 35€, selon le modèle.",
    },
    {
        title: "Renforcement de coffre-fort",
        price: "160€ à 260€",
        to: "/coffre-fort",
        text: "Pour bien sécuriser vos objets de valeur, nous consolidons la serrure de votre coffre-fort : entre 160€ pour les petits modèles et 260€ pour les modèles encastrables.",
    },
    {
        title: "Installation de porte blindée",
        price: "sur devis",
        to: "/porte-blindee",
        text: "Notre personnel qualifié vous accompagne dans l'installation de votre porte blindée, avec des conseils d'experts sur ses atouts. La réalisation d'un devis gratuit est nécessaire pour connaître le prix de la prestation.",
    },
    {
        title: "Installation de rideau métallique",
        price: "dès 85€",
        to: "/rideau-metallique",
        text: "Experts en installation et fabrication de rideaux métalliques : pose dès 85€, réparation dès 290€, rideaux sur mesure à tirage direct dès 320€, moteur central ou électrique dès 420€.",
    },
];

const CONFIANCE = [
    {
        title: "Un bon serrurier fait un état des lieux avant d'agir",
        text: "Si votre serrure est encore en état de marche et peut être réparée, un professionnel honnête ne vous incitera pas à en acheter une autre. Il analyse minutieusement le problème, vous explique la situation et vous propose les solutions possibles. En cas de doute, demandez un devis de serrurerie avant de vous décider.",
    },
    {
        title: "Un bon serrurier vous proposera toujours un devis au juste prix",
        text: "Un serrurier honnête réalise un devis avant d'intervenir, même sans que vous le demandiez. Vous y trouverez le détail de tous les coûts, ainsi que les coordonnées de l'artisan sur le devis et la facture. Un bon serrurier est également agréé assurances.",
    },
];

const FAQ_SP = [
    {
        q: "Êtes-vous de vrais artisans parisiens ou une centrale téléphonique ?",
        a: "Nous sommes une entreprise artisanale basée à Paris, active depuis 1985. Nos serruriers sont des employés directs, non des sous-traitants recrutés via une plateforme. Vous avez accès au numéro direct de l'artisan qui intervient chez vous, et notre facture comporte notre numéro SIRET, notre adresse et notre numéro d'assurance responsabilité civile professionnelle.",
    },
    {
        q: "Quels arrondissements de Paris couvrez-vous ?",
        a: "Nous intervenons dans les 20 arrondissements de Paris (75001 à 75020) ainsi que dans toute la petite couronne : Hauts-de-Seine (92), Seine-Saint-Denis (93), Val-de-Marne (94). Nous couvrons également la grande couronne : Yvelines (78), Essonne (91), Val-d'Oise (95) et Seine-et-Marne (77) pour les urgences.",
    },
    {
        q: "Quels sont vos tarifs de nuit et le week-end ?",
        a: "Nos tarifs de base ne varient pas selon l'heure pour la plupart des prestations. Un supplément de 20 € à 30 € peut s'appliquer pour les interventions entre 22h et 7h du matin. Le week-end et les jours fériés, aucun supplément n'est appliqué. Ces informations vous sont communiquées au téléphone avant tout déplacement.",
    },
    {
        q: "Comment savoir si mon devis est au juste prix ?",
        a: "Les prix de la serrurerie sont libres, mais ils doivent vous être annoncés avant l'intervention, avec un devis écrit. Méfiez-vous des annonces sans prix ou avec des mentions « dès 19 € » : ces prix n'incluent jamais la main-d'œuvre réelle.",
    },
    {
        q: "Êtes-vous agréés par les assurances habitation ?",
        a: "Oui. Nous sommes agréés par les principales compagnies d'assurance habitation. Nous émettons une facture conforme (SIRET, TVA, détail des pièces et de la main-d'œuvre) et, sur demande, un rapport d'intervention utile pour votre déclaration de sinistre. Votre assureur peut rembourser tout ou partie de la prestation selon votre contrat.",
    },
    {
        q: "Puis-je obtenir un devis gratuit avant l'intervention ?",
        a: "Oui. Appelez-nous ou remplissez le formulaire en ligne : nous vous fournissons une estimation par téléphone, ou nous déplaçons un technicien pour établir un devis écrit sans engagement. Aucun frais de déplacement n'est facturé si vous refusez le devis.",
    },
];

const ZONES_PARIS = [
    { arr: "1er – 4ème", delai: "20 min", quartiers: "Marais, Île de la Cité, Louvre, Châtelet" },
    { arr: "5ème – 7ème", delai: "20 min", quartiers: "Latin, Luxembourg, Invalides, Tour Eiffel" },
    { arr: "8ème – 10ème", delai: "25 min", quartiers: "Champs-Élysées, Opéra, République, Canal Saint-Martin" },
    { arr: "11ème – 13ème", delai: "25 min", quartiers: "Bastille, Nation, Gobelins, Italie" },
    { arr: "14ème – 16ème", delai: "25 min", quartiers: "Montparnasse, Trocadéro, Passy, Auteuil" },
    { arr: "17ème – 20ème", delai: "30 min", quartiers: "Batignolles, Montmartre, Belleville, Père Lachaise" },
];

export default function SerrurierParis() {
    return (
        <div data-testid="serrurier-paris-page">
            <SEO
                title="Serrurier Paris & Île-de-France (93, 92, 94, 91, 95, 77, 78) | Devis Gratuit"
                description="Serrurier Paris, spécialiste ouverture de porte (60€ TTC), changement de serrure, porte blindée sur Paris et toute l'Île-de-France. Artisan agréé assurance depuis 1985, chez vous en 25 min. ☎ 06 25 25 86 19"
                path="/serrurier-paris"
            />

            <section className="grain relative overflow-hidden bg-midnight py-10 text-white md:py-16">
                <div className="pointer-events-none absolute -right-24 top-0 h-80 w-80 rounded-full bg-emergency/20 blur-3xl" />
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <nav className="mb-8 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/50" data-testid="breadcrumb">
                        <Link to="/" className="transition-colors hover:text-gold">Accueil</Link>
                        <span>/</span>
                        <span className="text-gold">Serrurier Paris</span>
                    </nav>
                    <SectionLabel dark>Paris & 93, 92, 94, 91, 95, 77, 78</SectionLabel>
                    <StatusBadge className="mt-6" />
                    <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
                        <MaskedLines delay={0.15} lines={["Serrurier Paris :"]} />
                        <MaskedLines delay={0.45} lines={["le spécialiste de la serrurerie."]} lineClassName="text-gold" />
                    </h1>
                    <FadeUp delay={0.55}>
                        <p className="mt-6 max-w-xl leading-relaxed text-white/70">
                            Dépannage serrurerie sur Paris et toute l'Île-de-France. Prestation de qualité, serrurier
                            agréé, chez vous en 25 minutes. Devis gratuit, agréé assurance.
                        </p>
                        <a
                            href={PHONE_TEL}
                            data-testid="serrurier-paris-call-button"
                            className="mt-8 inline-flex items-center gap-3 bg-emergency px-8 py-4 text-lg font-bold text-white transition-colors hover:bg-emergency-dark"
                        >
                            <Phone className="h-5 w-5" /> {PHONE_DISPLAY}
                        </a>
                    </FadeUp>
                </div>
            </section>

            <EditorialMarquee dark={false} />

            {/* INTRO */}
            <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
                <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
                    <div>
                        <FadeUp>
                            <SectionLabel>Notre savoir-faire</SectionLabel>
                            <h2 className="mt-4 font-display text-4xl font-extrabold tracking-tight md:text-5xl">
                                Dépannage serrure à Paris et en Île-de-France
                            </h2>
                        </FadeUp>
                        <FadeUp delay={0.1}>
                            <p className="mt-6 leading-relaxed text-midnight/70">
                                Afin de vivre en toute sérénité, il est toujours mieux d'avoir un système antivol
                                efficace et des portes dotées de serrures de qualité. Ceux qui ont déjà eu affaire à
                                une clé coincée dans une serrure connaissent la difficulté à localiser un serrurier
                                pas cher et fiable.
                            </p>
                            <p className="mt-4 leading-relaxed text-midnight/70">
                                Composée d'une équipe d'artisans experts, notre entreprise intervient dans tous les
                                quartiers de Paris (75001 à 75020) et en Île-de-France (77, 78, 91, 92, 93, 94 et 95).
                                En France, une maison se fait cambrioler en moyenne toutes les deux minutes : c'est
                                pourquoi nous proposons des prestations de qualité, effectuées à temps et à des prix
                                abordables — de l'ouverture de porte au remplacement de serrure, en passant par la
                                copie de clé.
                            </p>
                        </FadeUp>
                    </div>
                    <FadeUp delay={0.12}>
                        <div className="flex aspect-[4/3] w-full items-center justify-center rounded-xl bg-midnight/5 p-4 shadow-[0_24px_60px_-20px_rgba(10,17,40,0.28)]">
                            <img
                                src={IMG("serrurier-ouverture-de-porte.webp")}
                                alt="Serrurier Paris pas cher — artisan en intervention"
                                className="h-full w-full object-contain"
                                width="500"
                                height="300"
                                loading="lazy"
                            />
                        </div>
                    </FadeUp>
                </div>
            </section>

            {/* SERVICES DÉTAILLÉS */}
            <section className="bg-white py-16 md:py-24">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <FadeUp>
                        <SectionLabel>Panel complet</SectionLabel>
                        <h2 className="mt-4 font-display text-4xl font-extrabold tracking-tight md:text-5xl">
                            Les services proposés par Serrurier Paris
                        </h2>
                    </FadeUp>
                    <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
                        {SERVICES_DETAIL.map((s, i) => (
                            <FadeUp key={s.title} delay={(i % 3) * 0.08}>
                                <Link
                                    to={s.to}
                                    data-testid={`sp-service-${i}`}
                                    className="group flex h-full flex-col justify-between border border-midnight/10 bg-cloud p-8 transition-all duration-300 hover:-translate-y-2 hover:border-midnight hover:bg-white hover:shadow-[0_28px_60px_-20px_rgba(10,17,40,0.35)]"
                                >
                                    <div>
                                        <span className="bg-midnight px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-gold">{s.price}</span>
                                        <h3 className="mt-5 font-display text-2xl font-extrabold tracking-tight">{s.title}</h3>
                                        <p className="mt-3 text-sm leading-relaxed text-midnight/60">{s.text}</p>
                                    </div>
                                    <span className="mt-6 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-emergency">
                                        Découvrir <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                                    </span>
                                </Link>
                            </FadeUp>
                        ))}
                    </div>
                </div>
            </section>

            {/* CONFIANCE */}
            <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
                <FadeUp>
                    <SectionLabel>Conseils</SectionLabel>
                    <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold tracking-tight md:text-5xl">
                        Trouver un serrurier de confiance à Paris, où que vous soyez
                    </h2>
                </FadeUp>
                <div className="mt-12 grid gap-5 md:grid-cols-2">
                    {CONFIANCE.map((c, i) => (
                        <FadeUp key={c.title} delay={i * 0.08}>
                            <div className="h-full border-l-2 border-gold bg-white p-8" data-testid={`sp-conseil-${i}`}>
                                <h3 className="font-display text-xl font-extrabold leading-snug tracking-tight">{c.title}</h3>
                                <p className="mt-4 text-sm leading-relaxed text-midnight/60">{c.text}</p>
                            </div>
                        </FadeUp>
                    ))}
                </div>
                <FadeUp delay={0.15}>
                    <div className="grain mt-12 bg-midnight p-8 text-white md:p-12" data-testid="sp-pourquoi">
                        <h3 className="font-display text-2xl font-extrabold tracking-tight md:text-3xl">
                            Pourquoi vous confier à Serrurier Paris ?
                        </h3>
                        <div className="mt-6 grid gap-4 sm:grid-cols-2">
                            {[
                                "Prestations de qualité et pas chères sur Paris 75001 à 75020 et les départements 91, 78, 93, 92, 95 et 94",
                                "Des artisans experts, disponibles même très tard dans la nuit, les week-ends et les jours de fête",
                                "Chez vous en seulement 20 minutes après votre appel téléphonique",
                                "Devis gratuit pour estimer le coût de chaque prestation, sans engagement",
                            ].map((item) => (
                                <p key={item} className="flex items-start gap-3 text-sm leading-relaxed text-white/75">
                                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {item}
                                </p>
                            ))}
                        </div>
                    </div>
                </FadeUp>
            </section>

            {/* ZONES PARIS */}
            <section className="bg-cloud py-16 md:py-24">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <FadeUp>
                        <SectionLabel>Couverture géographique</SectionLabel>
                        <h2 className="mt-4 font-display text-4xl font-extrabold tracking-tight md:text-5xl">
                            Serrurier dans tous les quartiers de Paris
                        </h2>
                        <p className="mt-6 max-w-3xl leading-relaxed text-midnight/70">
                            Nos artisans sont positionnés en permanence dans plusieurs zones de Paris pour minimiser
                            les délais d'intervention. Voici les délais indicatifs selon les secteurs. En dehors des
                            heures de pointe, nous arrivons généralement dans les temps annoncés.
                        </p>
                    </FadeUp>
                    <div className="mt-10 overflow-x-auto border border-midnight/10 bg-white">
                        <table className="w-full min-w-[560px] text-left">
                            <thead>
                                <tr className="bg-midnight text-white">
                                    <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Secteur</th>
                                    <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Délai moyen</th>
                                    <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider">Quartiers principaux</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-midnight/10">
                                {ZONES_PARIS.map((z, i) => (
                                    <FadeUp key={z.arr} delay={i * 0.04} as="tr" className="transition-colors hover:bg-cloud">
                                        <td className="px-6 py-4 font-semibold">{z.arr}</td>
                                        <td className="px-6 py-4 font-display text-lg font-extrabold text-[#f97316]">{z.delai}</td>
                                        <td className="px-6 py-4 text-sm text-midnight/65">{z.quartiers}</td>
                                    </FadeUp>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <FadeUp delay={0.25}>
                        <div className="mt-10 grid gap-6 lg:grid-cols-2">
                            <div className="bg-white border border-midnight/10 p-8">
                                <h3 className="font-display text-xl font-extrabold tracking-tight">
                                    Nos engagements qualité
                                </h3>
                                <ul className="mt-5 space-y-3 text-midnight/70">
                                    {[
                                        "Devis écrit remis avant toute intervention",
                                        "Facture détaillée conforme aux exigences des assureurs (SIRET, TVA, pièces séparées de la main-d'œuvre)",
                                        "Artisans assurés en responsabilité civile professionnelle",
                                        "Garantie pièces et main-d'œuvre de 2 ans sur les cylindres posés",
                                        "Aucun frais de déplacement facturé si vous refusez le devis",
                                    ].map((item) => (
                                        <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
                                            <Check className="mt-0.5 h-4 w-4 shrink-0 text-emergency" /> {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="bg-white border border-midnight/10 p-8">
                                <h3 className="font-display text-xl font-extrabold tracking-tight">
                                    Comment repérer un serrurier sérieux ?
                                </h3>
                                <p className="mt-4 leading-relaxed text-sm text-midnight/70">
                                    Le marché parisien de la serrurerie compte malheureusement de nombreux opérateurs
                                    peu scrupuleux. Ils utilisent des annonces avec des prix attractifs (« dès 19 € »)
                                    qui ne reflètent pas le coût réel de l'intervention, surfacturent sur place et
                                    disparaissent ensuite.
                                </p>
                                <p className="mt-3 leading-relaxed text-sm text-midnight/70">
                                    Avant d'accepter une intervention, vérifiez que l'artisan dispose d'un numéro SIRET
                                    vérifiable sur le site de l'INPI, d'une adresse physique, et qu'il vous remet un devis
                                    signé avant de commencer. Refusez toute intervention sans devis écrit remis avant de commencer.
                                </p>
                                <Link
                                    to="/bon-serrurier-paris"
                                    className="mt-5 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-emergency"
                                >
                                    Guide anti-arnaques <ArrowRight className="h-4 w-4" />
                                </Link>
                            </div>
                        </div>
                    </FadeUp>
                </div>
            </section>

            {/* FAQ SERRURIER PARIS */}
            <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
                <FadeUp>
                    <SectionLabel>Questions fréquentes</SectionLabel>
                    <h2 className="mt-4 font-display text-4xl font-extrabold tracking-tight md:text-5xl">
                        FAQ — Serrurier Paris
                    </h2>
                </FadeUp>
                <div className="mt-10 space-y-4">
                    {FAQ_SP.map((item, i) => (
                        <FadeUp key={item.q} delay={i * 0.06}>
                            <details className="group border border-midnight/10 bg-white">
                                <summary className="flex cursor-pointer items-center justify-between px-7 py-5 font-display text-lg font-bold tracking-tight">
                                    {item.q}
                                    <ArrowRight className="h-4 w-4 shrink-0 rotate-90 transition-transform group-open:rotate-[270deg]" />
                                </summary>
                                <div className="px-7 pb-6 pt-1 leading-relaxed text-midnight/70">{item.a}</div>
                            </details>
                        </FadeUp>
                    ))}
                </div>
            </section>


            {/* CTA */}
            <section className="grain bg-midnight py-16 text-white md:py-20">
                <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-8 px-4 sm:px-6 lg:px-8">
                    <div>
                        <h2 className="font-display text-3xl font-extrabold tracking-tight md:text-4xl">
                            Un artisan chez vous en 25 minutes.
                        </h2>
                        <p className="mt-3 text-white/60">Devis gratuit au téléphone — Paris & Île-de-France, 24h/24.</p>
                    </div>
                    <a
                        href={PHONE_TEL}
                        data-testid="sp-bottom-call-button"
                        className="flex items-center gap-3 bg-emergency px-8 py-4 text-lg font-bold text-white transition-colors hover:bg-emergency-dark"
                    >
                        <Phone className="h-5 w-5" /> {PHONE_DISPLAY}
                    </a>
                </div>
            </section>
        </div>
    );
}
